module.exports = __webpack_public_path__ + "img/2.7999db1d.png";